<template>
    <div>
      <div>
        <HomeVue v-if="view == 'home'" />
        <MaintenanceVue @setView="setView" v-if="view == 'mantenimiento'" />
        <ReportVue @setView="setView" v-if="view == 'report'" />
        <ProcessVue @setView="setView" v-if="view == 'process'" />
      </div>
      <FooterVue v-if="view == 'home'" :view="view" @setView="setView" />
    </div>
  </template>
  
  <script>
  import FooterVue from "../../components/administradorHowert/Footer.vue";
  import HomeVue from "../../components/administradorHowert/Home.vue";
  import MaintenanceVue from "../../views/maintenance/index.vue";
  import ReportVue from "../reporthowert/ReportHowert.vue";
  import ProcessVue from "../processAdmin/ProcessView.vue";

  
  export default {
    components: { FooterVue, HomeVue, MaintenanceVue, ReportVue, ProcessVue},
    data() {
      return {
        view: "home",
        booFooter:true
      };
    },
    methods: {
      setView: function (payload) {
        this.view = payload;
      },
      mtdViewFooter: function (boo, view) {
        this.booFooter = boo;
        if (boo == true) this.view = view;
      }
    },
  };
  </script>
  
  <style lang="scss" scoped></style>
  